import { Icon, IconProps } from "../";

export const ArrowForwardBriefIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.20041 4.98966C7.91856 5.2932 7.93613 5.76775 8.23966 6.0496L14.6478 12L8.23966 17.9504C7.93613 18.2323 7.91856 18.7068 8.20041 19.0103C8.48226 19.3139 8.95681 19.3314 9.26034 19.0496L16.2603 12.5496C16.4132 12.4077 16.5 12.2086 16.5 12C16.5 11.7915 16.4132 11.5923 16.2603 11.4504L9.26034 4.95041C8.95681 4.66856 8.48226 4.68613 8.20041 4.98966Z"
      />
    </Icon>
  );
};
